// Vehicle cluster-source options. "Group into a count" (organization crowding
// mode) lets clusters hold at every zoom, but only while the user's own
// "Cluster vehicles" toggle is on.
export function clusterOptionsFor({ clusterEnabled, crowding }) {
  return {
    cluster: clusterEnabled,
    clusterMaxZoom: crowding === 'group' && clusterEnabled ? 22 : 14,
    clusterRadius: 50,
  };
}
